import { useAtomValue } from 'jotai';
import usePdpOptionsOrderAtom from './usePdpOptionsOrderAtom';
const usePdpOptionsOrder = () => {
  const pdpOptionsOrderAtom = usePdpOptionsOrderAtom();
  const pdpOptionsOrder = useAtomValue(pdpOptionsOrderAtom);
  return pdpOptionsOrder;
};
export default usePdpOptionsOrder;